import * as React from "react"
import gsap from "gsap"; // <-- import GSAP
import { useGSAP } from "@gsap/react"; // <-- import the hook from our React package

import { ScrollTrigger } from 'gsap/dist/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);


export default () => {
  useGSAP(() => {
    gsap.timeline({
      defaults: {
        duration: 1,
        delay: 1,
        ease: 'power4.in'
      },
      scrollTrigger: {
        trigger: "#icon-target",
        // start: "center bottom-=100px",
        // end: "bottom+=50px bottom",
        start: "top center",
        end: "bottom center",
        markers: false,
        // onEnter, onLeave, onEnterBack, onLeaveBack
        // toggleActions: "play none reset play"
        toggleActions: "play none play reset"
      }
    }).fromTo('.icon-target-arrow', {
        duration: .4,
        x: 50,
        y: -50,
        opacity: 0,
      }, {
        x: 0,
        y: 0,
        opacity: 1,
      })
    });

 return (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 132.3 132.3" width="100" id="icon-target">
      <g fill="#001e5d">
        <path d="m126.8,39.7c-.45-1.04-1.46-1.7-2.58-1.7-.39,0-.78.08-1.15.24-.69.3-1.23.86-1.5,1.56-.28.7-.26,1.48.04,2.17,3.33,7.64,5.02,15.77,5.02,24.17,0,33.35-27.13,60.48-60.48,60.48S5.67,99.5,5.67,66.15,32.8,5.67,66.15,5.67c8.42,0,16.57,1.69,24.21,5.03.36.16.74.24,1.13.24,1.13,0,2.15-.67,2.6-1.7.3-.69.32-1.46.04-2.17-.28-.71-.81-1.26-1.51-1.57-8.36-3.66-17.26-5.51-26.47-5.51C29.67,0,0,29.67,0,66.15s29.67,66.15,66.15,66.15,66.15-29.67,66.15-66.15c0-9.2-1.85-18.1-5.5-26.45Z"/>
        <path d="m83.05,30.3c1.12,0,2.13-.67,2.58-1.71.3-.69.32-1.47.04-2.17-.28-.7-.81-1.26-1.5-1.56-5.69-2.49-11.76-3.75-18.02-3.75-24.84,0-45.05,20.21-45.05,45.05s20.21,45.05,45.05,45.05,45.05-20.21,45.05-45.05c0-6.26-1.26-12.32-3.75-18.01-.45-1.04-1.47-1.71-2.59-1.71-.39,0-.77.08-1.14.24-.69.3-1.23.86-1.5,1.56-.28.7-.26,1.48.04,2.17,2.17,4.96,3.27,10.26,3.27,15.74,0,21.71-17.66,39.37-39.37,39.37s-39.37-17.66-39.37-39.37,17.66-39.37,39.37-39.37c5.48,0,10.78,1.1,15.76,3.28.37.16.75.25,1.15.25Z"/>
        <path d="m66.15,47.88c1.25,0,2.48.12,3.66.37.19.04.38.06.56.06,1.34,0,2.5-.96,2.78-2.28.31-1.53-.69-3.03-2.22-3.34-1.56-.32-3.17-.48-4.78-.48-13.2,0-23.94,10.74-23.94,23.94s10.74,23.94,23.94,23.94,23.94-10.74,23.94-23.94c0-1.62-.16-3.24-.49-4.82-.27-1.31-1.44-2.26-2.79-2.26-.19,0-.38.02-.55.05-1.53.31-2.52,1.81-2.21,3.35.25,1.21.37,2.45.37,3.68,0,10.07-8.2,18.27-18.27,18.27s-18.27-8.2-18.27-18.27,8.2-18.27,18.27-18.27Z"/>
        <path class="icon-target-arrow" d="m93.08,18.64c-.15.35-.22.72-.22,1.08v15.14c0,.37-.15.72-.41.98l-28.31,28.31c-1.1,1.11-1.1,2.91,0,4.01.54.54,1.25.83,2,.83s1.47-.3,2.01-.83l28.31-28.31c.26-.26.61-.41.98-.41h15.14c.37,0,.73-.07,1.08-.22.35-.15.67-.35.93-.62l16.87-16.88c.26-.26.47-.57.61-.92.28-.69.28-1.48,0-2.17-.28-.69-.84-1.25-1.53-1.53-.35-.15-.71-.22-1.08-.22h-12.66c-.76,0-1.39-.62-1.39-1.39V2.84c0-.37-.07-.73-.22-1.08-.28-.69-.84-1.25-1.53-1.53-.34-.14-.71-.21-1.08-.21s-.74.07-1.08.21c-.35.15-.67.36-.93.62l-16.87,16.88c-.26.26-.47.57-.61.92Zm5.45,2.83c0-.37.15-.72.41-.98l8.44-8.44c.26-.27.62-.41.98-.41.18,0,.36.03.53.11.52.21.85.72.85,1.28v6.69c0,1.56,1.27,2.84,2.84,2.84h6.69c.56,0,1.07.34,1.28.85.21.52.1,1.11-.3,1.51l-8.44,8.44c-.26.26-.61.41-.98.41h-10.92c-.76,0-1.39-.62-1.39-1.38v-10.91Z"/>
      </g>
  </svg>
 );
}